import { render, staticRenderFns } from "./SendPromoSmsModel.vue?vue&type=template&id=82267aa2"
import script from "./SendPromoSmsModel.vue?vue&type=script&lang=js"
export * from "./SendPromoSmsModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports